import { render, staticRenderFns } from "./trainingModulePageNew13.vue?vue&type=template&id=239ce3a8&scoped=true&"
import script from "./trainingModulePageNew13.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew13.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew13.vue?vue&type=style&index=0&id=239ce3a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ce3a8",
  null
  
)

export default component.exports